import { render, staticRenderFns } from "./DoctorEditTabInformation.vue?vue&type=template&id=61a06996&scoped=true&"
import script from "./DoctorEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./DoctorEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./DoctorEditTabInformation.vue?vue&type=style&index=0&id=61a06996&lang=scss&scoped=true&"
import style1 from "./DoctorEditTabInformation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a06996",
  null
  
)

export default component.exports